import { memo } from "react";
import { Table } from "antd";

import { PillPagination } from "../PillPagination";



function InvoiceTableComponent({
  columns,
  dataSource,
  loading,
  page,
  pageSize,
  totalCount,
  onPageChange,
  toUiInvoiceStatus,
}) {
  return (
    <>
      <Table
        columns={columns}
        dataSource={dataSource}
        loading={loading}
        rowKey={(r) =>
          `${r.invoiceId || "invoice"}|${r.projectId || "project"}|${r.sowId || "sow"}|${r.revenueMonth || "month"}`
        }
        size="small"
        pagination={false}
        rowClassName={(r) => {
          const status = toUiInvoiceStatus(
            r.approvalStatusInFieldglass,
            r.invoicingStatus,
            Boolean(r.revenueMonth),
          );
          if (status === "Rejected") return "ant-table-row-danger";
          if (status === "Pending") return "ant-table-row-warning";
          return "";
        }}
      />
      <PillPagination
        currentPage={page}
        pageSize={pageSize}
        total={totalCount}
        itemLabel="records"
        onPageChange={(p) => onPageChange(p, pageSize)}
        pageSizeOptions={[10, 20, 50, 100]}
        onPageSizeChange={(size) => onPageChange(1, size)}
      />
    </>
  );
}

export const InvoiceTable = memo(InvoiceTableComponent);